export const strongPassword = (password) => {
  const regex = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W+)(?=^.{8,50}$).*$/g;
  return regex.test(password);
};
